/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { applyMiddleware, legacy_createStore as createStore, Reducer } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { composeWithDevTools } from '@redux-devtools/extension';

import { rootReducer } from './rootReducer';
import { rootSaga } from './rootSaga';

const sagaMiddleware = createSagaMiddleware();

export type ReducerCombinedState = ReturnType<typeof rootReducer>;

export type StoreInitialState = Partial<ReducerCombinedState>;

export const configureStore = (
  args: {
    initialState?: StoreInitialState;
    sagaMw?: ReturnType<typeof createSagaMiddleware>;
  } = {},
) => {
  const { initialState, sagaMw = sagaMiddleware } = args;
  // Redux 5 infers a `never` preloaded state for reducers typed with specific action unions
  const reducer = rootReducer as Reducer<ReducerCombinedState, Parameters<typeof rootReducer>[1], StoreInitialState>;
  return createStore(reducer, initialState, composeWithDevTools(applyMiddleware(sagaMw)));
};

export const store = configureStore();

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof rootReducer>;
